import { Component, forwardRef, ViewChild, Input, ViewChildren, QueryList } from '@angular/core';
import { PlatformApiService, Results, ResultFilter } from '../../services/platform-api.service';
import { FormGroup, FormControl, FormGroupDirective, NgForm } from '@angular/forms';
import { Account} from '../../models/AccountModel';
import { WizardScreenComponent } from 'src/app/shared/wizard.component';
import { DataTableComponent } from 'src/app/shared/tile-data-table/tile-data-table.component';
import { ManageAccountMappingModel } from 'src/app/models/ManageModel';
import { ManageCompanyDropdownComponent } from 'src/app/shared/manage-company-dropdown';
import { ManageIntegrationModel } from 'src/app/models/ManageIntegrationModel';
import { ErrorStateMatcher } from '@angular/material/core';

@Component({
  selector: 'cw-ci-account-manage-companies',
  templateUrl: './account-manage-companies.component.html',
  styleUrls: ['./account-manage-companies.component.scss'],
  providers: [{provide: WizardScreenComponent, useExisting: forwardRef(() => AccountManageCompaniesComponent)}]
})
export class AccountManageCompaniesComponent extends WizardScreenComponent {
  @ViewChild(DataTableComponent, { static: true }) userDataTable: DataTableComponent;
  @ViewChildren(ManageCompanyDropdownComponent) dropdowns: QueryList<ManageCompanyDropdownComponent>;
  @Input() account: Account;
  @Input() hasManageIntegration: boolean;
  subAccountList: Results<Account>;
  private mappings : ManageAccountMappingModel[] = new Array();
  invalidManageIds: number[] = new Array();
  unmappedCompaniesCount = 0;
  private currentUnmappedCompaniesCount = 0;
  private dirty = false;

  constructor(private _apiService: PlatformApiService) {
    super();
    this.form = new FormGroup ({});
    this.preventClose = true;
  }

  onLoad() {
    this.currentUnmappedCompaniesCount = this.unmappedCompaniesCount;
    this.mappings = new Array();
    this.invalidManageIds = new Array();
    this.userDataTable.executeLoadItems();
    if(this.currentUnmappedCompaniesCount == 0) {
      this.notifyWizardComponent('MANAGE_INTEGRATION_COMPANIES_MAPPED');
    }
    super.onLoad();
  }

  onSave(isNext: boolean) {
    this.showSpinner('Saving...');
    if(!isNext && (!this.isDirty() || !this.hasManageIntegration)){
      super.onSave(isNext);
    } else {
      this._apiService.saveManageSubAccountMappings(this.account.id, this.mappings, isNext).subscribe(
        data => {
          this.hideSpinner();
          console.log(data);
          this.dirty = false;
          if(data.enabledIntegration) {
            this.showPrompt('Manage Integration is complete and has been enabled. To make any additional changes, manage your companies within the Companies page and users within Settings.', () => {
              super.onSave(isNext);
              this.notifyWizardComponent('MANAGE_INTEGRATION_ENABLED');
            }, null, true, 'Manage Integration Enabled');

          } else {
            this.showPrompt('Saving your progress. Once all companies are successfully matched, and Save & Enable is selected, Manage Integration will be enabled.', () => {
              super.onSave(isNext);
              this.notifyWizardComponent('ENABLE_MANAGE_INTEGRATION_CHECKBOX');
            }, null, true, 'Saving Progress');
          }
        }
      );
    }
  }

  loadSubaccounts(filter = new ResultFilter()) {
    this.showSpinner();

    console.log('loadSubaccounts', filter);

    if(this.hasManageIntegration) {
      this._apiService.getSubAccounts(this.account.id, filter).subscribe(
        results => {
          this.subAccountList = results;
          for(const subAccount of this.subAccountList.results) {
            let isNewMapping = true;
            this.mappings.forEach(mapping => {
              if(mapping.accountId == subAccount.id) {
                isNewMapping = false;
                if(!subAccount.planId) {
                  subAccount.partner = new ManageIntegrationModel();
                }
                subAccount.partner.companyRecId = mapping.manageCompanyId;
                subAccount.partner.manageCompanyName = mapping.manageCompanyName;
              }
            })
            if(subAccount.partner && isNewMapping) {
              this.mappings.push({accountId: subAccount.id, manageIntegrationId: subAccount.partner.id, manageCompanyId: subAccount.manageIntegration.companyRecId, manageCompanyName: subAccount.name});
              subAccount.partner.manageCompanyName = subAccount.name;
            }
          }
          this.hideSpinner();
        }
      );
    } else {
      this.subAccountList = new Results([], 0);
      this.hideSpinner();
    }
  }

  handleEvent(item, event) {
    const accountId = item.id;
    let oldCompanyId;
    if(event.state == 'ONSELECT') {
      const manageIntegrationId = item.partner ? item.partner.id : null;
      const manageCompanyId = event.selection.option.value.value
      const manageCompanyName = event.selection.option.value.description;
      let isNewMapping = true;

      this.mappings.forEach(mapping => {
        if(mapping.accountId == accountId) {
          isNewMapping = false;

          oldCompanyId = mapping.manageCompanyId;
          mapping.manageCompanyId = manageCompanyId;
          mapping.manageCompanyName = manageCompanyName;
        }
      })
      if(isNewMapping) {
        this.mappings.push({accountId, manageIntegrationId, manageCompanyId, manageCompanyName});
        this.currentUnmappedCompaniesCount--;
      }

      if(oldCompanyId) {
        this.invalidManageIds.forEach((invalidManageId,index) =>{if(invalidManageId == oldCompanyId) {this.invalidManageIds.splice(index,1)}});
      }

      if(this.mappings.filter(mapping => mapping.manageCompanyId == manageCompanyId).length > 1) {
        this.invalidManageIds.push(manageCompanyId);
      }
    } else {
      this.mappings.forEach((mapping, index) => {
        if(mapping.accountId == accountId) {
          oldCompanyId = mapping.manageCompanyId;
          if(mapping.manageCompanyId) {
            this.currentUnmappedCompaniesCount++;
          }
          mapping.manageCompanyId = undefined;
          mapping.manageCompanyName = undefined;
        }
      })

      if(oldCompanyId) {
        this.invalidManageIds.forEach((invalidManageId,index) =>{if(invalidManageId == oldCompanyId) {this.invalidManageIds.splice(index,1)}});
      }
    }
    this.notifyWizardComponent('MANAGE_INTEGRATION_COMPANIES_MAPPED');
    this.dirty = true;
  }

  checkIfError(dropDown) {
    if(dropDown.searchControl.value && this.invalidManageIds.some(id=> id == dropDown.searchControl.value.value)) {
      return true;
    } else {
      return false;
    }
  }

  isDirty() {
    return this.dirty;
  }

  isValid() {
    return this.invalidManageIds.length == 0;
  }

  isPreviousButtonDisabled() {
    return !this.isValid();
  }

  isSaveButtonDisabled() {
    return !this.hasManageIntegration || !this.isValid();
  }

  getProgressPercent() {
    if(this.subAccountList && this.subAccountList.count > 0) {
      return Math.round(((this.subAccountList.count - this.currentUnmappedCompaniesCount) / this.subAccountList.count) * 100) + '%';
    } else {
      return '100%'
    }
  }
}